/**
 * @Author: shenyi
 * @Date:   2023-07-10 14:41:37
 * @Last Modified by:   shenyi
 * @Last Modified time: 2023-11-15 14:19:46
 */
import axios from "../lib/api.request";

export const getAppInfoApi = ({ appName = "", navUrl = "" }) => {
  return axios.request({
    url: navUrl || "/phoenix/health/api/v1/pcUIDefine/getTopBarInfo",
    method: "get",
    noLoading: true,
    params: { appName },
  });
};
export const getBaseDataApi = () => {
  return axios.request({
    url: "/phoenix/health/api/v1/baseData/zoneList",
    method: "get",
    noLoading: true,
  });
};
export const validate = (token?: string) => {
  return axios.request({
    url: "/phoenix/api/v2/authentication/token/validate?token=" + token,
    method: "get",
    noLoading: true,
  });
};
export const getAppMenuApi = ({ appName = "", leftMenuApi = "" }) => {
  return axios.request({
    url: leftMenuApi || "/phoenix/health/api/v1/pcUIDefine/getFunctionItems",
    method: "get",
    noLoading: true,
    params: { appName },
  });
};
export const getPersonDataApi = ({
  url = "",
  searchText = "",
  pageSize = 10,
  userType = "",
} = {}) => {
  return axios.request({
    url: url || "/phoenix/usercenter3/api/v2/pc/selector/user/search",
    method: "post",
    noLoading: true,
    data: { searchText, pageSize, userType },
  });
};
export const getGroupUserSelectTabTree = ({ selectType = "" } = {}) => {
  return axios.request({
    url: "/phoenix/usercenter3/api/v2/pc/selector/groupuser/getOrganizations",
    method: "get",
    noLoading: true,
    params: { selectType },
  });
};
// 退出登录
export const doLogout = (token = "") => {
  return axios.request({
    url: "/phoenix/api/v2/authentication/pcLogin/login/doLogout",
    method: "post",
    noLoading: true,
    data: { token },
  });
};
// 获取全校学生列表
export const getStudentList = () => {
  return axios.request({
    url: "/phoenix/health/api/v1/baseData/getAllStudent",
    method: "get",
  });
};
// 获取部门下拉框
export const getDepartments = (categorys) => {
  return axios.request({
    url: "/phoenix/usercenter3/api/v2/selector/department/findDepartments",
    method: "get",
    params: { categorys },
  });
};
export const getOrganizationPersonList = ({
  organizationId,
  selectType,
  organizationType,
}) => {
  console.log({ organizationId, selectType, organizationType });
  return axios.request({
    url: "/phoenix/usercenter3/api/v2/pc/selector/groupuser/getUsersByOrganizationId",
    method: "get",
    params: { organizationId, selectType, organizationType },
  });
};
// 楼宇级联下拉
export const getBuildingsSelector = (noLoading = true, noMessage = true) => {
  return axios.request({
    url: "/phoenix/schoolbaseMgr/api/v1/commonInfo/footstone/selector/getBuilding",
    method: "get",
    noLoading,
    noMessage,
  });
};
// 获取系统中的所有枚举值（单个系统）
export const getEnum = (url = "") => {
  return axios.request({
    url: url,
    method: "get",
    noLoading: true,
  });
};
// head
// 功能矩阵matrix
export const getMatrixData = () => {
  console.log("getMatrixData");
  return axios.request({
    url: "/phoenix/portal/api/v3/pc/functionMatrix/getMatrix",
    method: "get",
  });
};
export const getIndexNewUrl = () => {
  console.log("getMatrixData");
  return axios.request({
    url: "/phoenix/portal/api/pc/newIndex/getIndexNewUrl",
    method: "get",
  });
};
export const saveLog = (props: any) => {
  return axios.request({
    url: "/phoenix/portal/api/v5/portal/mgr/record/saveLog",
    method: "post",
    data: props,
  });
};
// 页面顶部用户信息
export const getLoginUserInfo = () => {
  return axios.request({
    url: "/phoenix/portal/api/v2/pc/loginUser/getLoginUserInfo",
    method: "get",
  });
};
// 获得未读消息总数
export const getTopMsgNumber = () => {
  return axios.request({
    url: "/phoenix/msg/api/v1/pc/msgcenter/header/getTopMsgNumber",
    method: "get",
  });
};
// 获取未读通知
export const getTopUnReadNotice = () => {
  return axios.request({
    url: "/phoenix/msg/api/v1/pc/msgcenter/usernotice/getTopUnReadNotice",
    method: "get",
  });
};
// 获取未读消息
export const getTopUnReadMessage = () => {
  return axios.request({
    url: "/phoenix/msg/api/v1/pc/msgcenter/usermessage/getTopUnReadMessage",
    method: "get",
  });
};
// 获取未读todo
export const getTopUnReadTodo = () => {
  return axios.request({
    url: "/phoenix/msg/api/v1/pc/msgcenter/usertodo/getTopUnReadTodo",
    method: "get",
  });
};
// 标记通知已读
export const markNoticeRead = (noticeId = "") => {
  return axios.request({
    url: "/phoenix/msg/api/v2/pc/msgcenter/usernotice/markNoticeRead",
    method: "post",
    data: { noticeId },
  });
};
// 获取通知详情
export const getNoticeDetail = (noticeId = "") => {
  return axios.request({
    url: "/phoenix/msg/api/v2/pc/msgcenter/usernotice/getNoticeDetail",
    method: "get",
    params: { noticeId },
  });
};
// 标记Todo已读
export const markReadTodo = (todoIds = []) => {
  return axios.request({
    url: "/phoenix/msg/api/v1/pc/msgcenter/usertodo/markRead",
    method: "post",
    data: { todoIds },
  });
};
// 标记全部todo已读
export const markAllReadTodo = () => {
  return axios.request({
    url: "/phoenix/msg/api/v1/pc/msgcenter/usertodo/markAllRead",
    method: "post",
    data: {},
  });
};
// todo标志为完成
export const finishTodo = (todoId: string) => {
  return axios.request({
    url: "/phoenix/msg/api/v1/pc/msgcenter/usertodo/finish",
    method: "post",
    data: { todoId },
  });
};
// 删除todo
export const deleteTodo = (todoIds = []) => {
  return axios.request({
    url: "/phoenix/msg/api/v1/pc/msgcenter/usertodo/delete",
    method: "post",
    data: { todoIds },
  });
};
// 标记消息已读
export const markReadMessage = (messageIds = []) => {
  return axios.request({
    url: "/phoenix/msg/api/v1/pc/msgcenter/usermessage/markRead",
    method: "post",
    data: { messageIds },
  });
};
// 标记全部消息已读
export const markAllReadMessage = () => {
  return axios.request({
    url: "/phoenix/msg/api/v1/pc/msgcenter/usermessage/markAllRead",
    method: "post",
    data: {},
  });
};
// 回复通知
export const answerNotice = (noticeId: string, answerContent: string) => {
  return axios.request({
    url: "/phoenix/msg/api/v1/pc/msgcenter/usernotice/answerNotice",
    method: "post",
    data: { noticeId, answerContent },
  });
};
// 删除消息
export const deleteMessage = (messageIds = []) => {
  return axios.request({
    url: "/phoenix/msg/api/v1/pc/msgcenter/usermessage/delete",
    method: "post",
    data: { messageIds },
  });
};
// 数据查询提示词
export const querySearchTip = (searchText = "") => {
  return axios.request({
    url: "/galaxy/dataquery/api/v1/pc/search/index/querySearchTip",
    method: "post",
    data: { searchText },
  });
};
